export interface PayAction {
    animation: any;
    time: number;

    // LinesPresentationModule uses
    framesTime?: number;
}